import AppRoutes from "./router/appRoutes.tsx";
import "./App.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import getQueryClientConfig from "config/react-query-config.ts";
import "./styles/index.css";
import "./styles/globalStyles.css";

function App() {
  const queryClient = new QueryClient(getQueryClientConfig());
  

  return (
    <QueryClientProvider client={queryClient}>
      <AppRoutes />
    </QueryClientProvider>
  );
}

export default App;
